import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Dropdown } from "react-bootstrap";
import { getDate, convertDate } from "utils/formatDate";
import { useSelector, useDispatch } from "react-redux";
import { formatNumber } from "utils/currencyFormat";
import { DSNhanVayConst } from "../../constants/nhanVayConst";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachHang } from "./ChiTietKhachHang/BtnChiTietKhachHang";
import { LaiSuatText } from "constants/choVayConst";
import choVayConst from "constants/choVayConst";
import { formatDayMonth } from "utils/formatDate";
import QuanLyChoVayApi from "../../service/quanLyThuChiApi";
import { pushNotification } from "utils/notifications";

export const ContentTable = ({
  listData,
  onSearch,
  setDataSearch,
  dataSearch,
  choVay,
  toggleModalQR,
  isQRThanhToan,
  setDisableXacNhan,
}) => {
  //active khi chọn 1 dòng table

  let isShow = false;
  if (matchMedia) {
    var mq = window.matchMedia("(max-width: 768px)");
    isShow = mq.matches;
  }

  const ThanhToan = (chovayid, sotien) => {
    setDisableXacNhan(true);
    QuanLyChoVayApi.thanhToan({
      choVayId: chovayid,
      soTien: sotien,
    }).then((response) => {
      if (response.data != 0) {
        pushNotification(
          "Thanh toán thành công",
          "success",
          "TOP_CENTER",
          2000
        );
        onSearch(dataSearch);
        setDisableXacNhan(false);
        return;
      } else {
        setDisableXacNhan(false);
        pushNotification("Có lỗi xảy ra", "error", "TOP_CENTER", 2000);
        return;
      }
    });
  };

  return listData.map((item, index) => {
    let date = convertDate(getDate());
    let NoteTitle = "";
    if (item.NoteCV) NoteTitle += "Ghi chú: " + item.NoteCV;
    if (item.NoteGiaHan) NoteTitle += "Gia hạn: " + item.NoteGiaHan;
    let ngayTra = convertDate(item.NgayTra);
    var getTimeNoGoc = convertDate(getDate());
    if (item.TimeNoGocChoVay !== null) {
      getTimeNoGoc = convertDate(item.TimeNoGocChoVay);
    }
    let msgGoc = "";
    if (item.Type === 3 || item.Type === 1) {
      if (item.TienGocConNo > 0) {
        if (getTimeNoGoc < date) {
          msgGoc = "Quá hạn trả gốc";
        }
        if (formatDayMonth(getTimeNoGoc) === formatDayMonth(date)) {
          msgGoc = "Hôm nay trả gốc";
        }
      }
    }

    if (item.Type === 2) {
      if (ngayTra < date) {
        msgGoc = "Quá hạn trả gốc";
      }
    }
    return (
      <>
        <div
          className={
            "custom-table-row " + (item === choVay && !isShow ? "active" : "")
          }
          key={"item" + index}
        >
          <div className="custom-table-cell username-cell flex-basis-4 flex-basis-6-sm disk-mobile">
            <span className="mobile-column-name">STT</span>
            <div className="center-wrapper">
              <p className="text-center">
                {index + 1 + (dataSearch.iPageIndex - 1) * 20}
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-9 flex-basis-15-6-sm">
            <span className="mobile-column-name">Mã hợp đồng</span>
            <div className="center-wrapper">
              <span className="profile_name">
                <BtnChiTietHopDong item={item} />
                <br />
                <span className="font-lai  color7">
                  {getDate(item.NgayVay)}{" "}
                </span>{" "}
                <br />{" "}
                <span className="font-lai  color7">
                  {" "}
                  {getDate(item.NgayTra)}{" "}
                </span>
              </span>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-9 flex-basis-11-8-sm">
            <span className="mobile-column-name">Tên khách hàng</span>
            <div className="center-wrapper">
              <p>
                <BtnChiTietKhachHang item={item} />
                <br />
                <span className="font-lai  color7">{item.Phone}</span>
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
            <span className="mobile-column-name">Số tiền vay</span>
            <div className="center-wrapper">
              <p className="text-right">
                <span className="fontnew-500 color-do-bold">
                  {formatNumber(item.Sotienvay)}
                </span>{" "}
                <br />{" "}
                <span className="font-lai  color7">
                  (Lãi suất: {LaiSuatText(item, item.KieuLaiSuat)})
                </span>
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
            <span className="mobile-column-name">Tổng nợ</span>
            <div className="center-wrapper">
              <p className="text-right">
                <span className="fontnew-500 color-do-bold">
                  {formatNumber(item.TienLaiConNo)}
                </span>
                <br />
                <span className="font-lai color7">
                  ({item.SoKyConNoTuTruocToiNay} kỳ)
                </span>
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-15 flex-basis-13-sm">
            <span className="mobile-column-name">Lý do</span>
            <div className="center-wrapper">
              <p className="text-left">
                {item.Type === 2 && (
                  <span className="font-lai  color7">
                    {" "}
                    Chậm {item.SoKyConNoTuTruocToiNay} Kỳ góp(
                    {item.NgayNoLaiFist} Ngày).
                  </span>
                )}
                {item.Type !== 2 && (
                  <span className="font-lai  color7">
                    {" "}
                    Chậm {item.SoKyConNoTuTruocToiNay} Kỳ lãi(
                    {item.NgayNoLaiFist} Ngày).
                  </span>
                )}

                {msgGoc !== null && msgGoc !== "" && (
                  <span className="font-lai  color7"> {msgGoc}</span>
                )}
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-30 flex-basis-13-sm">
            <span className="mobile-column-name">Đóng tiền nhanh</span>
            <div className="center-wrapper">
              <p className="text-left">
                {item[1] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[1])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[1])}
                      </span>
                    </a>
                  </>
                )}
                {item[2] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[2])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[2])}
                      </span>
                    </a>
                  </>
                )}
                {item[3] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[3])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[3])}
                      </span>
                    </a>
                  </>
                )}
                {item[4] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[4])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[4])}
                      </span>
                    </a>
                  </>
                )}
              </p>
              {isQRThanhToan && (
                <p className="text-left">
                  {item[1] != null && (
                    <>
                      <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[1]);
                        }}
                      >
                        <span style={{ width: "80px" }} className="badge badge">
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                  {item[2] != null && (
                    <>
                      <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[2]);
                        }}
                      >
                        <span style={{ width: "80px" }} className="badge badge">
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                  {item[3] != null && (
                    <>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[3]);
                        }}
                      >
                        <span
                          style={{ width: "80px" }}
                          className="badge badge "
                        >
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                  {item[4] != null && (
                    <>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[4]);
                        }}
                      >
                        <span
                          style={{ width: "80px" }}
                          className="badge badge "
                        >
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                </p>
              )}

              <p>
                {item[5] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[5])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[5])}
                      </span>
                    </a>
                  </>
                )}
                {item[6] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[6])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[6])}
                      </span>
                    </a>
                  </>
                )}
                {item[7] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[7])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[7])}
                      </span>
                    </a>
                  </>
                )}
                {item[8] != null && (
                  <>
                    <a onClick={(e) => ThanhToan(item.ChoVayId, item[8])}>
                      <span
                        style={{ width: "80px" }}
                        className="badge badge badge-info badge-pill"
                      >
                        {formatNumber(item[8])}
                      </span>
                    </a>
                  </>
                )}
              </p>
              {isQRThanhToan && (
                <p className="text-left">
                  {item[5] != null && (
                    <>
                      <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[5]);
                        }}
                      >
                        <span style={{ width: "80px" }} className="badge badge">
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                  {item[6] != null && (
                    <>
                      <a
                        href="javascript:void(0)"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[6]);
                        }}
                      >
                        <span style={{ width: "80px" }} className="badge badge">
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                  {item[7] != null && (
                    <>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[7]);
                        }}
                      >
                        <span
                          style={{ width: "80px" }}
                          className="badge badge "
                        >
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                  {item[8] != null && (
                    <>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleModalQR(item, item[8]);
                        }}
                      >
                        <span
                          style={{ width: "80px" }}
                          className="badge badge "
                        >
                          <img src="/app-assets/images/icon-qrcode-v2.png" />
                        </span>
                      </a>
                    </>
                  )}
                </p>
              )}
            </div>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-13-sm">
            <span className="mobile-column-name">Trạng thái</span>
            <div className="center-wrapper">
              <p className="text-center">
                <span
                  className={
                    item.Status === 4
                      ? "canh-bao-red-v2"
                      : item.Status === 3
                      ? "canh-bao-no"
                      : item.Status === 2
                      ? "dong"
                      : "dang-vay"
                  }
                >
                  {item.IsDuNoGiamDan === true && (
                    <>{choVayConst.StatusHoText[item.Status]}</>
                  )}
                  {(item.IsDuNoGiamDan === false ||
                    item.IsDuNoGiamDan === undefined) && (
                    <> {choVayConst.StatusText[item.Status]}</>
                  )}
                </span>
              </p>
            </div>
          </div>
        </div>
      </>
    );
  });
};
